import { IIcon } from '@rbilabs/components-library/build/themes';

import { StoreCardButtonOptions } from 'state/launchdarkly/variations';

/**
 * MAP BUTTON OPTIONS TO ICONS
 */
export const ACTION_BUTTON_ICONS = {
  [StoreCardButtonOptions.INFO]: 'info' as keyof IIcon,
  [StoreCardButtonOptions.OFFERS]: 'offer' as keyof IIcon,
  [StoreCardButtonOptions.ORDER]: 'order' as keyof IIcon,
};
